// src/i18n.js
import { createI18n } from 'vue-i18n';

// Mensajes de internacionalización
const messages = {
  es: {
    Acceder: 'Acceder',
    Accede_a_tu_perfil: 'Accede a tu perfil',
    Aceptable_aunque_puedes_mejorar: "Aceptable pero... ¡puedes mejorar!",
    Acceder_al_centro_sin_reserva: "Acceder al centro sin reserva",
    Acceso: "Acceso",
    Acceso_presencial: "Acceso presencial",
    Acceso_regulado_por_email: "Acceso regulado por correo electrónico",
    Acciones: 'Acciones',
    Actividad_dirigida_por: "Actividad dirigida por",
    actividad: 'actividad',
    Actividad: 'Actividad',
    actividades: 'actividades',
    Actividades: 'Actividades',
    Actividades_completadas: 'Actividades completadas',
    Actividad_reservada_para_residentes: "Actividad reservada para residentes de Vall d'Hebron",
    actualizado_con_éxito: "actualizado con éxito",
    Añadir: 'Añadir',
    Añadir_lección: "Añadir lección",
    Añadir_módulo: "Añadir módulo",
    Año_de_residencia: "Año de residencia",
    alumnos: 'alumnos',
    Alumnos_pendientes_de_evaluación: "Alumnos pendientes de evaluación",
    anterior: 'anterior',
    Apellidos: 'Apellidos',
    Aprende: 'Aprende',
    Áreas: 'Áreas',
    Aún_no_eres_docente_de_ninguna_actividad: '¿Aún no eres docente de ninguna actividad? Asegúrate de que los datos de tu perfil estén completos y correctos.',
    Aún_no_te_has_inscrito_a_ninguna_actividad: 'Aún no te has inscrito a ninguna actividad.',
    Avanzando_el_cribado_rutinario_del_embarazo_con_ecografía_asistida_por_IA: "Avanzando el Cribado Rutinario del Embarazo con Ecografía Asistida por IA",
    Buen_esfuerzo: "¡Buen esfuerzo!",
    Calendario: 'Calendario',
    Cambiar_contraseña: 'Cambiar contraseña',
    Características_de_la_actividad: 'Características de la actividad',
    Características_del_módulo: 'Características del módulo',
    Características_generales: 'Características generales',
    Características_avanzadas_opcionales: 'Características avanzadas (opcional)',
    cardio_es: 'CardioSIM es un programa integral de formación para residentes de Cardiología que combina teoría y práctica en un entorno virtual y físico de simulación. Accede a contenidos teóricos, reserva tu espacio en los simuladores y realiza evaluaciones online, todo en una sola plataforma.',
    cargando_reservas: 'cargando reservas...',
    Cancelar_reserva: 'Cancelar reserva',
    Cerrar: 'Cerrar',
    Cerrar_sesión: 'Cerrar sesión',
    Cesion_de_derechos: 'Cesión de derechos',
    Citaciones: 'Citaciones',
    Código_QR: 'Código QR',
    Código_QR_de_acceso: 'Código QR de acceso al Centro',
    Cómo_puedes_participar: "Cómo puedes participar",
    Cómo_puedes_participar_text: "Si deseas compartir tu opinión o conocer más sobre este proyecto, te invitamos a hacer clic en el botón a continuación para ponerte en contacto con nosotros. Al hacerlo, podrás:",
    Cómo_puedes_participar_text_c1: "Hacer preguntas o aportar sugerencias",
    Cómo_puedes_participar_text_c2: "Compartir tu experiencia personal o preocupaciones",
    Cómo_puedes_participar_text_c3: "Si representas a una organización, considerar enviar una carta de apoyo o brindar comentarios para ayudarnos a mejorar y difundir EmbryoScan.",
    Comprueba: 'Comprueba',
    Condiciones_de_uso_y_privacidad: 'Condiciones de uso y privacidad',
    Condiciones_gineSIM: 'Condiciones de uso y política de privacidad de Simulacio.com',
    Confirmación: 'Confirmación',
    Confirmación_de_Correo_Electrónico: 'Confirmación de Correo Electrónico',
    Confirmando_correo_electrónico: "Confirmando correo electrónico",
    Confirmar_nueva_contraseña: 'Confirmar nueva contraseña',
    Contáctanos: "Contáctanos",
    Contacto: 'Contacto',
    Contenido: 'Contenido',
    Contraseña: 'Contraseña',
    Contraseña_actual: 'Contraseña actual',
    Contraseña_restablecida_con_éxito: "¡Contraseña restablecida con éxito!",
    Corrección: 'Corrección',
    Correcto: 'Correcto',
    Correo_electrónico_confirmado_con_éxito: '¡Correo electrónico confirmado con éxito!',
    crea_activitat: 'Crea una actividad',
    creado_con_éxito: "creado con éxito",
    Crear: 'Crear',
    Crear_módulo: 'Crear módulo',
    cuestionario: 'cuestionario',
    datos: 'datos',
    Debes_seleccionar_al_menos_una_área_en_la_sección_de_visibilidad: "Debes seleccionar al menos un área en la sección de visibilidad.",
    Descargar: 'Descargar',
    Descripción: 'Descripción',
    Detalles_del_usuario: 'Detalles del usuario',
    día: 'día',
    Dificultad: 'Dificultad',
    Dirección: 'Dirección',
    Duración_de_la_actividad: "Duración de la actividad",
    DNI_opcional: 'DNI (opcional, para generar certificados)',
    Domina: 'Domina',
    Ecografías: 'Ecografías',
    Editar: 'Editar',
    el_día: 'el día',
    El_módulo: 'El módulo',
    Elige_un_día: 'Elige un día',
    eliminado_con_éxito: 'eliminado con éxito',
    Email: 'Correo electrónico',
    Email_institucional: 'Correo electrónico institucional',
    EmbryoScan_es: "EmbryoScan es un innovador proyecto de investigación con sede en Barcelona, llevado a cabo por el Hospital Universitario Vall d'Hebron en colaboración con la Universidad Pompeu Fabra.\nNuestra misión es mejorar las ecografías en las primeras etapas del embarazo, haciéndolas más informativas y menos estresantes para las embarazadas y sus familias. Tradicionalmente, la primera ecografía rutinaria se realiza alrededor de la semana 12. Nuestro objetivo es explorar si la tecnología avanzada puede permitir que este control esencial se realice de manera segura en la semana 10.\nMediante el uso de una ecografía transvaginal especializada que combina varias imágenes en una única reconstrucción 3D detallada, los médicos podrían detectar posibles problemas de forma más temprana, lo que permitiría mejorar el cuidado prenatal.",
    enviar: 'enviar',
    Enviar_solicitud: 'Enviar solicitud',
    Es_correcta: '¿Es correcta?',
    Esta_acción_eliminará_todas: "Esta acción eliminará todas sus lecciones y preguntas relacionadas de forma irreversible.",
    Estás_seguro: '¿Estás seguro/a?',
    Estás_seguro_que_quieres_eliminar: "¿Estás seguro/a que quieres eliminar",
    Evaluación: 'Evaluación',
    Evaluando_a: 'Evaluando a',
    Evaluar: 'Evaluar',
    Excelente: '!Excelente!',
    Explora: 'Explora',
    Explora_las_actividades: 'Explora las actividades',
    Externalizar: 'Externalizar',
    Fecha_de_fin: 'Fecha de fin',
    Fecha_de_inicio: 'Fecha de inicio',
    Fecha_inicio_especialidad: 'Fecha de inicio especialidad',
    Fecha_y_hora_de_inicio: "Fecha y hora de inicio",
    fue_actualizado_con_éxito: 'fue actualizado con éxito.',
    fue_creado_con_éxito: "fue creado con éxito.",
    Guardar: 'Guardar',
    Guardar_cambios: 'Guardar cambios',
    He_leído_y_acepto: 'Acepto que mis datos se almacenen en embryoscanner.com.',
    Hola: 'Hola',
    Home: 'Inicio',
    Hora_de_inicio: 'Hora de inicio',
    Hora_de_fin: 'Hora de fin',
    hoy: 'hoy',
    Idioma: 'Idioma',
    Imagen: 'Imagen',
    Incorrecto: 'Incorrecto',
    Índice_de_contenidos: "Índice de contenidos",
    Información_de_contacto: 'Información de contacto',
    Iniciando_la_sesión: "Iniciando la sesión",
    Iniciar_sesión: 'Iniciar sesión',
    inicio: 'inicio',
    Inspira: 'Inspira',
    Inspira_tus_alumnos: 'Inspira a tus alumnos:',
    Insitución: 'Institución',
    Inténtalo_de_nuevo: "¡Inténtalo de nuevo!",
    Investigadores: 'Investigadores',
    La_actividad: 'La actividad',
    la_actividad: "la actividad",
    La_leccion: 'La lección',
    lección: 'lección',
    lecciones: 'lecciones',
    libre: 'libre',
    listado: 'listado',
    Más_información: "Más información",

    mes: 'mes',
    Mirar: 'Mirar',
    módulo: 'módulo',
    modulos: 'módulos',
    No: 'No',
    No_eres_docente_de_ninguna_actividad: "No eres docente de ninguna actividad dirigida por otro profesional actualmente.",
    No_estás_inscrito_a_ninguna_actividad: "No estás inscrito a ninguna actividad actualmente.",
    No_has_creado_ninguna_actividad: "Todavía no has creado ninguna actividad.",
    No_has_recibido_el_email_de_verificacion: "¿No has recibido el email de verificación?",
    No_hay_alumnos_pendientes_de_evaluación: "No hay alumnos pendientes de evaluación.",
    No_hay_disponibilidad_de_reservas_para_el_simulador_de: 'No hay disponibilidad de reservas para el simulador de',
    No_recuerdas_tu_c: '¿No recuerdas tu contraseña?',
    No_tienes_cuenta: '¿No tienes cuenta?',
    No_tienes_ningún_simulador_reservado: 'No tienes ningún simulador reservado.',
    Nombre: 'Nombre',
    Nombre_de_usuario: 'Nombre de usuario',
    Nota_final: 'Nota final',
    Nueva_contraseña: 'Nueva contraseña',
    Número_de: 'Número de',
    Número_de_alumnos: 'Número de alumnos',
    Número_de_docentes: 'Número de docentes',
    ocupación: 'ocupación',
    Orden_guardado_con_éxito: 'Orden guardado con éxito.',
    opción: 'opción',
    Opciones: 'Opciones',
    Opciones_adicionales: 'Opciones adicionales',
    Para_acceder_a_la_actividad: "Para acceder a la actividad contacta con el Centro de Simulación.",
    Para_más_detalles: 'Para más detalles, consulte la',
    Para_ti: 'Para ti',
    Pendiente: 'Pendiente',
    Perfil: 'Perfil',
    Ponte_a_prueba: "¡Ponte a prueba!",
    Política_de_protección_de_datos: "Política de protección de datos",
    Política_VH: "Política de protección de datos de Vall d'Hebron Barcelona Hospital Campus",
    Por_favor_revisa_tu_email_para_continuar: "Por favor revisa tu email para continuar",
    Por_qué_es_importante: "¿Por qué es importante?",
    Por_qué_es_importante_text_c1: "Detección temprana: Identificar posibles complicaciones en la semana 10 podría dar a las mujeres embarazadas y sus familias más tiempo para prepararse y tomar decisiones informadas.",
    Por_qué_es_importante_text_c2: "Tecnología avanzada: La fusión de múltiples exploraciones en una vista 3D detallada permitirá obtener imágenes más precisas y completas del desarrollo del bebé.",
    Por_qué_es_importante_text_c3: "Menos estrés: Obtener respuestas antes puede reducir la incertidumbre y brindar tranquilidad en las primeras semanas del embarazo.",
    Por_qué_tu_opinión_es_clave: "Por qué tu opinión es clave",
    Por_qué_tu_opinión_es_clave_text: "Las experiencias y perspectivas de las embarazadas, familias y organizaciones de apoyo son clave para mejorar la atención prenatal. Tu opinión nos ayudará a hacer que EmbryoScan sea accesible, útil y realmente beneficioso para quienes esperan la llegada de un bebé.",
    Practica: 'Practica',
    Preguntas: 'Preguntas',
    preguntas: 'preguntas',
    Profesional: 'Profesional',
    Profesionales: 'Profesionales',
    Proyecto_embryoscan: 'Proyecto EmbryoScan',
    Puedes_ser_docente_de_esta_actividad: 'Puedes ser docente de esta actividad',
    puntos: 'puntos',
    Puntuación_práctica: 'Puntuación práctica',
    Puntuación_teórica: 'Puntuación teórica',
    Qué_es_EmbryoScan: "¿Qué es EmbryoScan?",
    Quieres_acceder_a_la_actividad: '¿Quieres acceder a la actividad',
    Recursos: 'Recursos',
    Restablecer_Contraseña: 'Restablecer Contraseña',
    Registrarse: 'Registrarse',
    Regístrate: "Regístrate",
    Registro: 'Registro',
    Reordenar: 'Reordenar',
    Reservar: 'Reservar',
    reservado: 'reservado',
    reservas: 'reservas',
    Reservas: 'Reservas',
    Rol: 'Rol',
    se_ha_eliminado_con_éxito: 'se ha eliminado con éxito.',
    Se_ha_enviado_un_correo_de_verificacion: "Se ha enviado un correo electrónico de verificación.",
    Seguro_cancelar_reserva: '¿Seguro que quieres cancelar tu reserva para',
    Selecciona_un_día_para_ver_disponibilidad: 'Selecciona un día para ver disponibilidad',
    Selecciona_un_simulador: 'Selecciona un simulador',
    semana: 'semana',
    Seudónimo: 'Seudónimo',
    Sí: 'Sí',
    Si_eres_residente_de_vh: "Si eres residente de Vall d'Hebron, utiliza tu correo electrónico institucional.",
    siguiente: 'siguiente',
    Simuladores: 'Simuladores',
    Solicitar_acceso: "Solicitar acceso",
    Sólo_pueden_crear_actividades_los_profesionales_de_Vallhebron: "Sólo pueden crear actividades los professionales de Vall d'Hebron.",
    Teléfono: 'Teléfono',
    Tipo: 'Tipo',
    Tipo_de: 'Tipo de',
    Título: 'Título',
    Todavía_no_has_completado_ninguna_actividad: "Todavía no has completado ninguna actividad. ¡Anímate!",
    Tu_progreso: 'Tu progreso',
    Tus_actividades: 'Tus actividades',
    Tus_actividades_docentes: 'Tus actividades docentes',
    Tus_datos_se_han_actualizado_correctamente: "Tus datos se han actualizado correctamente.",
    Tus_reservas: 'Tus reservas',
    Tu_voz_importa: "Tu voz importa",
    Tu_voz_importa_text: "Juntos, podemos avanzar hacia ecografías más tempranas y precisas, mejorando la experiencia prenatal para todas las familias. Gracias por tu interés en EmbryoScan. ¡Esperamos tu participación!",
    Únete_a_nosotros: "Únete a nosotros",
    Usuarios: 'Usuarios',
    usuario: 'usuario',
    vallhebron_es: "Te damos la bienvenida a la APP del Centro de Simulación Clínica Avanzada del Hospital Vall d'Hebron. Accede a contenidos teóricos, reserva tu espacio en los simuladores y realiza evaluaciones online, todo en una sola plataforma.",
    Verificar_Cuenta: 'Verifica tu cuenta',
    Visión_general: 'Visión general',
    Vista_alumno: 'Vista alumno',
    Vista_docente: 'Vista docente',
    Visibilidad: 'Visibilidad',
    Vuelve_a_escribir_la_c: 'Vuelve a escribir la contraseña',
    y_la: 'y_la',
    Ya_tienes_una_cuenta: '¿Ya tienes una cuenta?',

  },
  ca: {
    Acceder: 'Accedir',
    Accede_a_tu_perfil: 'Accedeix al teu perfil',
    Acceder_al_centro_sin_reserva: "Accedir al centre sense reserva",
    Acceso: "Accés",
    Acceso_presencial: "Accés presencial",
    Acceso_regulado_por_email: "Accés regulat per correu electrònic",
    Acciones: 'Accions',
    Aceptable_aunque_puedes_mejorar: "Acceptable... però pots millorar!",
    Actividad_dirigida_por: "Activitat dirigida per",
    actividad: 'activitat',
    Actividad: 'Activitat',
    actividades: 'activitats',
    Actividades: 'Activitats',
    Actividades_completadas: 'Activitats completades',
    Actividad_reservada_para_residentes: "Activitat reservada per a residents de Vall d'Hebron",
    actualizado_con_éxito: "actualitzat amb èxit",
    alumnos: 'alumnes',
    Alumnos_pendientes_de_evaluación: "Alumnes pendents d'avaluació",
    Añadir: 'Afegir',
    Añadir_lección: "Afegir lliçó",
    Añadir_módulo: "Afegir mòdul",
    Año_de_residencia: "Any de residència",
    anterior: 'anterior',
    Apellidos: 'Cognoms',
    Aprende: 'Aprèn',
    Áreas: 'Àrees',
    Aún_no_eres_docente_de_ninguna_actividad: "Encara no ets docent de cap activitat? Assegura't que les dades del teu perfil estiguin completes i correctes.",
    Aún_no_te_has_inscrito_a_ninguna_actividad: "Encara no t'has inscrit a cap activitat.",
    Avanzando_el_cribado_rutinario_del_embarazo_con_ecografía_asistida_por_IA: "Avançant el Cribratge Rutinari de l'Embaràs amb Ecografia Assistida per IA",
    Buen_esfuerzo: "Bon esforç!",
    Calendario: 'Calendari',
    Cambiar_contraseña: 'Canviar contrasenya',
    Cancelar_reserva: 'Cancel·lar reserva',
    Características_de_la_actividad: "Característiques de l'activitat",
    Características_del_módulo: 'Característiques del mòdul',
    Características_generales: 'Característiques generals',
    Características_avanzadas_opcionales: 'Característiques avançades (opcional)',
    cardio_es: "CardioSIM és un programa integral de formació per a residents de Cardiologia que combina teoria i pràctica en un entorn virtual i físic de simulació. Accedeix a continguts teòrics, reserva el teu espai als simuladors i realitza avaluacions en línia, tot en una sola plataforma.",
    cargando_reservas: 'carregant reserves...',
    Cerrar: 'Tancar',
    Cerrar_sesión: 'Tancar sessió',
    Cesion_de_derechos: 'Cessió de drets',
    Citaciones: 'Citacions',
    Código_QR: 'Codi QR',
    Código_QR_de_acceso: "Codi QR d'accés al Centre",
    Cómo_puedes_participar: "Com pots participar",
    Cómo_puedes_participar_text: "Si vols compartir la teva opinió o obtenir més informació sobre aquest projecte, et convidem a fer clic al botó següent per contactar amb nosaltres. En fer-ho, podràs:",
    Cómo_puedes_participar_text_c1: "Fer preguntes o aportar suggeriments",
    Cómo_puedes_participar_text_c2: "Compartir la teva experiència personal o preocupacions",
    Cómo_puedes_participar_text_c3: "Si representes una organització, considerar enviar una carta de suport o oferir comentaris per ajudar-nos a millorar i difondre EmbryoScan.",
    Comprueba: 'Comprova',
    Confirmación: 'Confirmació',
    Confirmación_de_Correo_Electrónico: 'Confirmació de Correu Electrònic',
    Confirmando_correo_electrónico: "Confirmant correu electrònic",
    Confirmar_nueva_contraseña: 'Confirmar nova contrasenya',
    Contacto: 'Contacte',
    Condiciones_de_uso_y_privacidad: "Condicions d'ús i privacitat",
    Contáctanos: "Contacta'ns",
    Contenido: 'Contingut',
    Contraseña: 'Contrasenya',
    Contraseña_actual: 'Contrasenya actual',
    Contraseña_restablecida_con_éxito: "La contrasenya s'ha restablert amb èxit!",
    Corrección: 'Correcció',
    Correcto: 'Correcte',
    Correo_electrónico_confirmado_con_éxito: 'Correu electrònic confirmat amb èxit!',
    crea_activitat: 'Crea una activitat',
    creado_con_éxito: "creat amb èxit",
    Crear: 'Crear',
    Crear_módulo: 'Crear mòdul',
    cuestionario: 'qüestionari',
    datos: 'dades',
    Debes_seleccionar_al_menos_una_área_en_la_sección_de_visibilidad: "Has de seleccionar al menys una àrea a la secció de visibilitat.",
    Descargar: 'Descarregar',
    Descripción: 'Descripció',
    Detalles_del_usuario: "Detalls de l'usuari",
    día: 'dia',
    Dificultad: 'Dificultat',
    Dirección: 'Direcció',
    DNI_opcional: 'DNI (opcional, per a generar certificats)',
    Domina: 'Domina',
    Duración_de_la_actividad: "Durada de l'activitat",
    Ecografías: 'Ecografies',
    Editar: 'Editar',
    Editar_módulo: 'Editar mòdul',
    el_día: 'el dia',
    El_módulo: 'El mòdul',
    Elige_un_día: 'Tria un dia',
    eliminado_con_éxito: 'eliminat amb èxit',
    Email: 'Correu electrònic',
    Email_institucional: 'Correu electrònic institucional',
    EmbryoScan_es: "EmbryoScan és un innovador projecte de recerca amb seu a Barcelona, dut a terme per l'Hospital Universitari Vall d'Hebron en col·laboració amb la Universitat Pompeu Fabra.\nLa nostra missió és millorar les ecografies en les primeres etapes de l'embaràs, fent-les més informatives i menys estressants per a les embarassades i les seves famílies. Tradicionalment, la primera ecografia rutinària es realitza al voltant de la setmana 12. El nostre objectiu és explorar si la tecnologia avançada pot permetre que aquest control essencial es faci de manera segura a la setmana 10.\nMitjançant l'ús d'una ecografia transvaginal especialitzada que combina diverses imatges en una única reconstrucció 3D detallada, els metges podrien detectar possibles problemes més aviat, cosa que permetria millorar l'atenció prenatal.",
    enviar: 'enviar',
    Enviar_solicitud: 'Enviar sol·licitud',
    Es_correcta: 'És correcta?',
    Esta_acción_eliminará_todas: "Aquesta acció eliminarà totes les seves lliçons i preguntes relacionades de manera irreversible.",
    Estás_seguro: "N'estàs segur/a?",
    Estás_seguro_que_quieres_eliminar: "N'estàs segur/a que vols eliminar",
    Evaluación: 'Avaluació',
    Evaluando_a: 'Avaluant a',
    Evaluar: 'Avaluar',
    Excelente: 'Excel·lent!',
    Explora: 'Explora',
    Explora_las_actividades: 'Explora les activitats',
    Externalizar: 'Externalitzar',
    Fecha_de_fin: 'Data de fi',
    Fecha_de_inicio: "Data d'inici",
    Fecha_inicio_especialidad: "Data d'inici de l'especialitat",
    Fecha_y_hora_de_inicio: "Data i hora d'inici",
    fue_actualizado_con_éxito: "s'ha actualitzat amb èxit.",
    fue_creado_con_éxito: "s'ha creat amb èxit.",
    Guardar: 'Desar',
    Guardar_cambios: 'Desar els canvis',
    He_leído_y_acepto: "Accepto que les meves dades s'emmagatzemin a embryoscanner.com.",
    Hola: 'Hola',
    Home: 'Inici',
    Hora_de_inicio: "Hora d'inici",
    Hora_de_fin: "Hora de fi",
    hoy: 'avui',
    Idioma: 'Idioma',
    Imagen: 'Imatge',
    Incorrecto: 'Incorrecte',
    Índice_de_contenidos: "Índex de continguts",
    Información_de_contacto: 'Informació de contacte',
    Iniciando_la_sesión: "Iniciant la sessió",
    Iniciar_sesión: 'Iniciar sessió',
    inicio: 'inici',
    Inspira: 'Inspira',
    Insitución: 'Institució',
    Inténtalo_de_nuevo: "Intenta-ho una altra vegada!",
    Investigadores: 'Investigadors',
    La_actividad: "L'activitat",
    la_actividad: "l'activitat",
    La_leccion: 'La lliçó',
    lección: 'lliçó',
    lecciones: 'lliçons',
    libre: 'lliure',
    listado: 'llistat',
    Más_información: "Més informació",
    mes: 'mes',
    Mejora_cardio: "Millora les teves habilitats en Cardiología a Vall d'Hebron Barcelona Hospital Campus.",
    Mejora_vallhebron: "Millora les teves habilitats pràctiques i coneixements a Vall d'Hebron Barcelona Hospital Campus.",
    Mejora_gine: "Millora les teves habilitats en Obstetrícia i Ginecologia a Vall d'Hebron Barcelona Hospital Campus.",
    Mirar: 'Mirar',
    modulos: 'mòduls',
    módulo: 'mòdul',
    No: 'No',
    No_has_creado_ninguna_actividad: "Encara no has creat cap activitat.",
    No_has_recibido_el_email_de_verificacion: "No has rebut l'email de verificació?",
    No_recuerdas_tu_c: 'No recordes la teva contrasenya?',
    No_tienes_cuenta: '¿No tens compte?',
    No_tienes_ningún_simulador_reservado: 'No tens cap simulador reservat.',
    Nombre: 'Nom',
    Nombre_de_usuario: "Nom d'usuari",
    Nota_final: 'Nota final',
    Nueva_contraseña: 'Nova contrasenya',
    Número_de: "Número de",
    Número_de_alumnos: "Número d'alumnes",
    Número_de_docentes: "Número de docents",
    ocupación: 'ocupació',
    opción: 'opció',
    Opciones: 'Opcions',
    Opciones_adicionales: 'Opcions addicionals',
    Orden_guardado_con_éxito: 'Ordre desat amb èxit.',
    Para_acceder_a_la_actividad: "Per a accedir a l'activitat contacta amb el Centre de Simulació.",
    Para_más_detalles: 'Per a més detalls, consulti la',
    Para_ti: 'Per a tu',
    Pendiente: 'Pendent',
    Perfil: 'Perfil',
    Política_de_protección_de_datos: "Política de protecció de dades",
    Política_VH: "Política de protecció de dades de Vall d'Hebron Barcelona Hospital Campus",
    Ponte_a_prueba: "Posa't a prova!",
    Por_favor_revisa_tu_email_para_continuar: "Si us plau, revisa el teu email per a continuar.",
    Por_qué_es_importante: "Per què és important?",
    Por_qué_es_importante_text_c1: "Detecció precoç: Identificar possibles complicacions a la setmana 10 podria donar més temps a les dones embarassades i les seves famílies per preparar-se i prendre decisions informades.",
    Por_qué_es_importante_text_c2: "Tecnologia avançada: La fusió de múltiples exploracions en una imatge 3D detallada permetrà obtenir imatges més precises i completes del desenvolupament del nadó.",
    Por_qué_es_importante_text_c3: "Menys estrès: Rebre respostes abans pot reduir la incertesa i aportar tranquil·litat durant les primeres setmanes de l'embaràs.",
    Por_qué_tu_opinión_es_clave: "Per què la teva opinió és clau",
    Por_qué_tu_opinión_es_clave_text: "Les experiències i perspectives de les embarassades, famílies i organitzacions de suport són clau per millorar l'atenció prenatal. La teva opinió ens ajudarà a fer que EmbryoScan sigui accessible, útil i realment beneficiós per a aquelles persones que esperen l'arribada d'un nadó.",
    Practica: 'Practica',
    Preguntas: 'Preguntes',
    preguntas: 'preguntes',
    Profesional: 'Professional',
    Profesionales: 'Professionals',
    Proyecto_embryoscan: 'Projecte EmbryoScan',
    Puedes_ser_docente_de_esta_actividad: "Pots ser docent d'aquesta activitat",
    puntos: 'punts',
    Puntuación_práctica: 'Puntuació pràctica',
    Puntuación_teórica: 'Puntuació teòrica',
    Qué_es_EmbryoScan: "Què és EmbryoScan?",
    Quieres_acceder_a_la_actividad: "Vols accedir a l'activitat",
    Recursos: 'Recursos',
    Restablecer_Contraseña: 'Restablir Contrasenya',
    Registrarse: 'Registrar-se',
    Regístrate: "Registra't",
    Registro: 'Registre',
    Reordenar: 'Reordenar',
    Reservar: 'Reservar',
    reservado: 'reservat',
    reservas: 'reserves',
    Reservas: 'Reserves',
    Rol: 'Rol',
    se_ha_eliminado_con_éxito: "s'ha eliminat amb èxit.",
    Se_ha_enviado_un_correo_de_verificacion: "S'ha enviat un correu electrònic de verificació.",
    Seguro_cancelar_reserva: 'Segur que vols cancel·lar la teva reserva per a',
    Selecciona_un_día_para_ver_disponibilidad: 'Selecciona un dia per a veure disponibilitat',
    Selecciona_un_simulador: 'Selecciona un simulador',
    semana: 'setmana',
    Seudónimo: 'Pseudònim',
    Sí: 'Sí',
    Si_eres_residente_de_vh: "Si ets resident de Vall d'Hebron, utilitza el teu correu electrònic institucional.",
    siguiente: 'següent',
    Simuladores: 'Simuladors',
    Solicitar_acceso: "Sol·licitar accés",
    Sólo_pueden_crear_actividades_los_profesionales_de_Vallhebron: "Només poden crear activitats els professionals de Vall d'Hebron.",
    Teléfono: 'Telèfon',
    Tipo: 'Tipus',
    Tipo_de: 'Tipus de',
    Título: 'Títol',
    Todavía_no_has_completado_ninguna_actividad: "Encara no has completat cap activitat. Anima-t'hi!",
    Tu_progreso: 'El teu progrés',
    Tus_actividades: 'Les teves activitats',
    Tus_actividades_docentes: 'Les teves activitats docents',
    Tus_datos_se_han_actualizado_correctamente: "Les teves dades s'han actualitzat correctament.",
    Tus_reservas: 'Les teves reserves',
    Tu_voz_importa: "La teva veu compta",
    Tu_voz_importa_text: "Junts, podem avançar cap a ecografies més precoces i precises, millorant l'experiència prenatal per a totes les famílies. Gràcies pel teu interès en EmbryoScan. Esperem la teva participació!",
    Únete_a_nosotros: "Uneix-te a nosaltres",
    Usuarios: 'Usuaris',
    usuario: 'usuari',
    vallhebron_es: "Et donem la benvinguda a l'APP del Centre de Simulació Clínica Avançada de l'Hospital Vall d'Hebron. Accedeix a continguts teòrics, reserva el teu espai als simuladors i realitza avaluacions en línia, tot en una sola plataforma.",
    Verificar_Cuenta: 'Verifica el teu compte',
    Visibilidad: 'Visibilitat',
    Visión_general: 'Visió general',
    Vista_alumno: 'Vista alumne',
    Vista_docente: 'Vista docent',
    Vuelve_a_escribir_la_c: 'Torna a escriure la contrasenya',
    y_la: 'i la',
    Ya_tienes_una_cuenta: 'Ja tens un compte?',
  },
  en: {
    Acceder: 'Access',
    Accede_a_tu_perfil: 'Access your profile',
    Acceder_al_centro_sin_reserva: "Access the center without reservation",
    Acceso: "Access",
    Acceso_presencial: "Presential access",
    Acceso_regulado_por_email: "Email regulated access",
    Acciones: 'Actions',
    Aceptable_aunque_puedes_mejorar: "Fine, but you can improve it!",
    Acepto_VH: "I agree that by accessing the Advanced Clinical Simulation Center of Vall d'Hebron Barcelona Hospital Campus using the QR codes generated in Simulacio.com, my personal data will be transferred to the center's database. I confirm my agreement with the privacy policies and image rights assignment of the Simulation Center.",
    Actividad_dirigida_por: "Activity directed by",
    actividad: 'activity',
    Actividad: 'Activity',
    actividades: 'activities',
    Actividades: 'Activities',
    Actividades_completadas: 'Completed activities',
    Actividad_reservada_para_residentes: "Activity reserved for Vall d'Hebron residents",
    actualizado_con_éxito: "successfully updated",
    alumnos: 'students',
    Alumnos_pendientes_de_evaluación: "Students pending evaluation",
    Añadir: 'Add',
    Añadir_lección: "Add lesson",
    Añadir_módulo: "Add section",
    Año_de_residencia: "Year of training",
    anterior: 'previous',
    Apellidos: 'Surname',
    Aprende: 'Learn',
    Áreas: 'Areas',
    Aún_no_eres_docente_de_ninguna_actividad: "Are you still not a teacher of any activity? Make sure that your profile details are complete and correct.",
    Aún_no_te_has_inscrito_a_ninguna_actividad: "You haven't enrolled in any activity yet.",
    Avanzando_el_cribado_rutinario_del_embarazo_con_ecografía_asistida_por_IA: "Advancing Routine Fetal Screening with AI-Assisted Ultrasound Analysis",
    Buen_esfuerzo: "Good attempt!",
    Calendario: 'Calendar',
    Cambiar_contraseña: 'Change password',
    Cancelar_reserva: 'Cancel reservation',
    Características_de_la_actividad: "Activity settings",
    Características_del_módulo: 'Module settings',
    Características_generales: 'General settings',
    Características_avanzadas_opcionales: 'Advanced settings (optional)',
    cardio_es: 'CardioSIM is a comprehensive training program for Cardiology residents that combines theory and practice in a virtual and physical simulation environment. Access theoretical content, reserve your space in simulators, and take online assessments, all on a single platform.',
    cargando_reservas: 'loading reservations...',
    Cerrar: 'Close',
    Cerrar_sesión: 'Log out',
    Cesion_de_derechos: 'Image and exploitation rights',
    Citaciones: 'Appointments',
    Código_QR: 'QR Code',
    Código_QR_de_acceso: 'Access QR Code to the Center',
    Cómo_puedes_participar: "How You Can Get Involved",
    Cómo_puedes_participar_text: "If you're interested in sharing your thoughts or learning more about this project, we invite you to click the button below to contact us. By reaching out, you can:",
    Cómo_puedes_participar_text_c1: "Ask questions or share suggestions",
    Cómo_puedes_participar_text_c2: "Share your personal experiences or concerns",
    Cómo_puedes_participar_text_c3: "If you represent a patient organization, consider submitting a letter of support or offering feedback to help us refine and promote EmbryoScan.",
    Comprueba: 'Check',
    Condiciones_de_uso_y_privacidad: 'Terms of Use and Privacy',
    Condiciones_gineSIM: 'Simulacio.com Terms of Use and Privacy Policy',
    Confirmación: 'Confirmation',
    Confirmación_de_Correo_Electrónico: 'Email Confirmation',
    Confirmando_correo_electrónico: "Confirming email",
    Confirmar_nueva_contraseña: 'Confirm new password',
    Contáctanos: "Contact us",
    Contacto: 'Contact',
    Contenido: 'Content',
    Contraseña: 'Password',
    Contraseña_actual: 'Current Password',
    Contraseña_restablecida_con_éxito: "Password was successfully reset!",
    Corrección: 'Correction',
    Correcto: 'Correct',
    Correo_electrónico_confirmado_con_éxito: 'Email successfully confirmed!',
    crea_activitat: 'Create new activity',
    creado_con_éxito: "successfully created",
    Crear: 'Create',
    Crear_módulo: 'Create section',
    cuestionario: 'test',
    datos: 'dades',
    Debes_seleccionar_al_menos_una_área_en_la_sección_de_visibilidad: "You must select at least one area in the visibility section.",
    Descargar: 'Download',
    Descripción: 'Description',
    Detalles_del_usuario: 'User Details',
    día: 'day',
    Dificultad: 'Difficulty',
    Dirección: 'Address',
    DNI_opcional: 'DNI (optional, for generating certificates)',
    Domina: 'Master',
    Duración_de_la_actividad: "Activity duration",
    Ecografías: 'Scans',
    Editar: 'Edit',
    Editar_módulo: 'Edit module',
    el_día: 'on the day',
    El_módulo: 'The module',
    Elige_un_día: 'Choose a date',
    eliminado_con_éxito: 'successfully deleted',
    Email: 'Email',
    Email_institucional: 'Institutional email',
    EmbryoScan_es: "EmbryoScan is an innovative research project based in Barcelona, conducted by Vall d'Hebron University Hospital in collaboration with Pompeu Fabra University. Our mission is to enhance early pregnancy ultrasounds, making them more informative and less stressful for expectant parents. Traditionally, the first routine ultrasound occurs around 12 weeks. We aim to explore whether advanced technology can safely move this essential check-up to as early as 10 weeks. By using a specialized transvaginal ultrasound and combining multiple scans into a single, detailed 3D image, doctors may be able to detect potential issues earlier, allowing for better-informed care and decision-making.",
    enviar: 'send',
    Enviar_solicitud: 'Send request',
    Es_correcta: 'Is it correct?',
    Esta_acción_eliminará_todas: "This action will irreversibly delete all your lessons and related questions.",
    Estás_seguro: "Are you sure?",
    Estás_seguro_que_quieres_eliminar: "Are you sure you want to delete",
    Evaluación: 'Evaluation',
    Evaluando_a: 'Evaluating',
    Evaluar: 'Evaluate',
    Excelente: 'Excellent!',
    Explora: 'Explore',
    Explora_las_actividades: 'Explore activities',
    Externalizar: 'Externalize',
    Fecha_de_fin: 'Ending date',
    Fecha_de_inicio: "Start date",
    Fecha_inicio_especialidad: 'Specialty Start Date',
    Fecha_y_hora_de_inicio: "Start date and time",
    fue_actualizado_con_éxito: 'was successfully updated.',
    fue_creado_con_éxito: "has been successfully created.",
    Guardar: 'Save',
    Guardar_cambios: 'Save changes',
    He_leído_y_acepto: "I agree to my data being stored in embryoscanner.com.",
    Hola: 'Hello',
    Home: 'Home',
    Hora_de_inicio: "Start time",
    Hora_de_fin: "Ending time",
    hoy: 'today',
    Idioma: 'Language',
    Incorrecto: 'Incorrect',
    Inténtalo_de_nuevo: "Try again!",
    Imagen: 'Image',
    Índice_de_contenidos: "Index of contents",
    Información_de_contacto: 'Contact Information',
    Iniciando_la_sesión: "Logging in",
    Iniciar_sesión: 'Sign in',
    inicio: 'home',
    Inspira: 'Inspire',
    Inspira_tus_alumnos: 'Inspire your students:',
    Insitución: 'Institution',
    Investigadores: 'Researchers',
    La_actividad: 'The activity',
    la_actividad: "the activity",
    La_leccion: 'The lesson',
    lección: 'lesson',
    lecciones: 'lessons',
    libre: 'free',
    listado: 'list',
    Más_información: "Learn more",
    Mejora_cardio: "Improve your skills in Cardiología at Vall d'Hebron Barcelona Hospital Campus.",
    Mejora_vallhebron: "Improve your practical skills and knowledge at Vall d'Hebron Barcelona Hospital Campus.",
    Mejora_gine: "Improve your skills in Obstetrics and Gynecology at Vall d'Hebron Barcelona Hospital Campus.",

    mensaje_para_residentes_con_menos_experiencia: "This activity is intended for residents with less than {experiencia_maxima} years of experience in the specialty.",
    mensaje_para_residentes_con_al_menos_experiencia: "This activity is intended for residents who have at least {experiencia_minima} years of experience in the specialty.",
    mensaje_para_residentes_con_rango_experiencia: "This activity is intended for residents who have between {experiencia_minima} and {experiencia_maxima} years of experience in the specialty.",

    mes: 'month',
    Mirar: 'View',
    modulos: 'modules',
    módulo: 'module',
    No: 'No',
    No_eres_docente_de_ninguna_actividad: "You are not a teacher for any activity directed by another professional currently.",
    No_estás_inscrito_a_ninguna_actividad: "You are not currently enrolled in any activity.",
    No_has_creado_ninguna_actividad: "You haven't created any activities yet.",
    No_has_recibido_el_email_de_verificacion: "Didn't receive the verification email?",
    No_hay_alumnos_pendientes_de_evaluación: "No students pending evaluation.",
    No_hay_disponibilidad_de_reservas_para_el_simulador_de: 'There is no reservation availability for the simulator of',
    No_recuerdas_tu_c: "Don't remember your password?",
    No_tienes_cuenta: "Don't have an account?",
    No_tienes_ningún_simulador_reservado: 'You have no simulator reserved.',
    Nombre: 'Name',
    Nombre_de_usuario: 'Username',
    Nota_final: 'Final mark',
    Nueva_contraseña: 'New Password',
    Número_de: 'Number of',
    Número_de_alumnos: 'Number of students',
    Número_de_docentes: 'Number of teachers',
    ocupación: 'occupation',
    opción: 'option',
    Opciones: 'Options',
    Opciones_adicionales: 'Additional options',
    Orden_guardado_con_éxito: 'Order successfully saved.',
    Para_acceder_a_la_actividad: "To access the activity, contact the Simulation Center.",
    Para_más_detalles: 'For more details, please see the',
    Para_ti: 'For you',
    Pendiente: 'Pending',
    Perfil: 'Profile',
    Política_de_protección_de_datos: "Privacy Policy",
    Política_VH: "Privacy Policy of Vall d'Hebron Barcelona Hospital Campus",
    Ponte_a_prueba: "Challenge yourself!",
    Por_favor_revisa_tu_email_para_continuar: "Please check your email to continue.",
    Por_qué_es_importante: "Why is This Important?",
    Por_qué_es_importante_text_c1: "Early Detection: Identifying potential problems at 10 weeks could give pregnant women and their families more time to prepare and make informed decisions.",
    Por_qué_es_importante_text_c2: "Advanced Technology: Merging multiple scans into a comprehensive 3D view will allow for highly accurate and detailed images of the developing baby.",
    Por_qué_es_importante_text_c3: "Less Stress: Receiving answers sooner can alleviate uncertainty and provide reassurance during the crucial early stages of pregnancy.",
    Por_qué_tu_opinión_es_clave: "Why We Value Your Opinion",
    Por_qué_tu_opinión_es_clave_text: "We believe that the insights and experiences of women, parents, and advocacy groups are essential in shaping the future of prenatal care. Your feedback will help us ensure that EmbryoScan is both user-friendly and truly beneficial for expectant families.",
    Practica: 'Practice',
    Preguntas: 'Questions',
    preguntas: 'questions',
    Profesional: 'Professional',
    Profesionales: 'Professionals',
    Proyecto_embryoscan: 'EmbryoScan Project',
    Puedes_ser_docente_de_esta_actividad: "You may be a teacher in this activity.",
    puntos: 'points',
    Puntuación_práctica: 'Practical score',
    Puntuación_teórica: 'Theoretical score',
    Qué_es_EmbryoScan: "What is EmbryoScan?",
    Quieres_acceder_a_la_actividad: "Do you want to access the activity",
    Recursos: 'Resources',
    Restablecer_Contraseña: 'Reset Password',
    Registrarse: 'Sign up',
    Regístrate: 'Register',
    Registro: 'Registration',
    Reordenar: 'Reorder',
    Reservar: 'Reserve slot',
    reservado: 'reserved',
    reservas: 'reservations',
    Reservas: 'Reservations',
    Rol: 'Role',
    se_ha_eliminado_con_éxito: 'has been successfully deleted.',
    Se_ha_enviado_un_correo_de_verificacion: "A verification email has been sent",
    Seguro_cancelar_reserva: 'Are you sure you want to cancel your reservation for',
    Selecciona_un_día_para_ver_disponibilidad: 'Select a day to view availability',
    Selecciona_un_simulador: 'Select a simulator',
    semana: 'week',
    Seudónimo: 'Nickname',
    Sí: 'Yes',
    Si_eres_residente_de_vh: "If you are a Vall d'Hebron resident, use your institutional email.",
    siguiente: 'next',
    Simuladores: 'Simulators',
    Solicitar_acceso: "Request Access",
    Sólo_pueden_crear_actividades_los_profesionales_de_Vallhebron: "Only Vall d'Hebron professionals can create new activities.",
    Teléfono: 'Phone',
    Tipo: 'Type',
    Tipo_de: 'Type of',
    Título: 'Title',
    Todavía_no_has_completado_ninguna_actividad: "You haven't completed any activity yet. Go for it!",
    Tu_progreso: 'Your progress',
    Tus_actividades: 'Your activities',
    Tus_actividades_docentes: 'Your teaching activities',
    Tus_datos_se_han_actualizado_correctamente: "Your data has been successfully updated.",
    Tus_reservas: 'Your reservations',
    Tu_voz_importa: "Your Voice Matters",
    Tu_voz_importa_text: "Together, we can work toward providing better, earlier ultrasounds, enhancing the prenatal journey for families everywhere. Thank you for your interest in EmbryoScan. We look forward to hearing from you!",
    Únete_a_nosotros: "Join us",
    Usuarios: 'Users',
    usuario: 'user',
    vallhebron_es: "We welcome you to the APP of the Advanced Clinical Simulation Center of the Vall d'Hebron Hospital. Access theoretical content, book your space in the simulators, and take online assessments, all in one platform.",
    Verificar_Cuenta: 'Verify your account',
    Visión_general: 'Overview',
    Visibilidad: 'Visibility',
    Vista_alumno: 'Student view',
    Vista_docente: 'Teacher view',
    Vuelve_a_escribir_la_c: 'Retype the password',
    y_la: 'and the',
    Ya_tienes_una_cuenta: 'Already have an account?',
  }

};

// Detectar el idioma preferido del navegador
const browserLocale = navigator.language.split('-')[0];

// Crear la instancia i18n con las opciones de configuración
const i18n = createI18n({
  legacy: false, // Usa la API de composición para Vue 3
  locale: browserLocale,
  fallbackLocale: 'es', // idioma de respaldo
  messages, // los mensajes de traducción
});

export default i18n;

